/** SEO-focused FAQs for Notrack (Indian audience, no calorie tracking, “Simple Diet Plan India”). */
export const seoFaqs = [
  {
    q: 'What is a simple diet plan in India for weight loss?',
    a: 'A simple diet plan in India focuses on consistent home meals—roti, rice, dal, vegetables, eggs, paneer, or chicken—with sensible portions and fewer fried snacks and sweet drinks. Notrack turns that pattern into daily guidance so you can follow a simple diet plan without counting every calorie.',
  },
  {
    q: 'Is Notrack a “Simple Diet Plan India” app?',
    a: 'Yes. Notrack is built for Indian kitchens and routines: clear daily structure for common Indian meals, habit-based consistency, and guidance that adapts—so you can search for a simple diet plan India approach and actually stick to it.',
  },
  {
    q: 'Do I need to track calories on a simple Indian diet plan?',
    a: 'No. Notrack replaces heavy logging with AI-based guidance and daily structure—so you get direction for real Indian food without turning every meal into math.',
  },
  {
    q: 'How does Notrack work without calorie tracking?',
    a: 'You follow simple daily guidance and quick check-ins. The system uses your consistency and progress to adjust recommendations over time—so you stay on track without logging every bite.',
  },
  {
    q: 'Can I eat normal Indian home food and still lose weight?',
    a: 'Yes. Notrack is designed around everyday Indian meals—not imported “diet foods.” The goal is structure and consistency with roti, rice, dal, sabzi, eggs, paneer, and chicken as you normally cook them.',
  },
  {
    q: 'Is Notrack personalized for my goal and lifestyle?',
    a: 'Yes. Your starting plan reflects your goal, food habits, and routine. As you check in, guidance adapts based on your consistency and progress.',
  },
  {
    q: 'What if I miss a day on my diet plan?',
    a: 'You continue. Missed days are normal. Notrack adapts so you are not forced to “restart from Monday” every time life gets busy.',
  },
  {
    q: 'Does a simple diet plan work for busy professionals in India?',
    a: 'It can—when the plan is realistic. Notrack emphasizes small daily actions (meal structure, protein, hydration, sleep-friendly habits) that fit office schedules, travel, and irregular days.',
  },
  {
    q: 'How is this different from calorie-counting apps?',
    a: 'Calorie apps depend on accurate logging—hard with Indian recipes that change daily. Notrack focuses on guidance, habits, and consistency so you are not guessing numbers for every bowl of dal or plate of rice.',
  },
  {
    q: 'Will Notrack tell me exactly what to eat every day?',
    a: 'You get clear daily structure and examples you can rotate—without rigid “only eat this” rules. The goal is direction you can follow with your own kitchen and preferences.',
  },
  {
    q: 'Is Notrack only for weight loss?',
    a: 'Notrack is positioned for sustainable fat loss and consistency using simple meals and habits. It is not a substitute for medical care—see a clinician for conditions, medications, or specialized diets.',
  },
  {
    q: 'Can vegetarians use Notrack for a simple diet plan?',
    a: 'Yes. Guidance can emphasize dal, legumes, dairy (where appropriate), vegetables, and sensible starch portions—still without requiring calorie tracking.',
  },
  {
    q: 'What about eating outside—restaurants, office cafeterias, travel?',
    a: 'Notrack focuses on practical patterns: protein + vegetables where possible, sensible starch portions, and avoiding “invisible calories” from fried snacks and sugary drinks—so you still have a plan on unpredictable days.',
  },
  {
    q: 'How fast will I see results with a simple diet plan?',
    a: 'Results vary by adherence, sleep, stress, and starting point. Most people benefit first from better consistency and energy; scale changes are usually gradual and healthier when habits stick.',
  },
  {
    q: 'Is Notrack medical advice?',
    a: 'No. Notrack provides general nutrition and habit guidance for healthy adults. For diabetes, thyroid issues, pregnancy, eating disorders, or any medical condition, consult a qualified clinician before changing your diet.',
  },
  {
    q: 'Which Indian cities does Notrack suit?',
    a: 'Notrack is built for Indian food culture broadly—whether you are in Mumbai, Bengaluru, Delhi NCR, Hyderabad, Chennai, Pune, or smaller towns. The principles map to common home-cooked meals and busy routines.',
  },
  {
    q: 'Do I need expensive groceries or meal replacements?',
    a: 'No. The system is built around normal Indian groceries and home cooking. The “upgrade” is structure and consistency—not specialty products.',
  },
  {
    q: 'How do I start with Notrack?',
    a: 'Join early access, pick a plan when prompted, and complete the short onboarding so your starting guidance matches your goal and food habits. Daily steps are designed to take seconds—not hours of logging.',
  },
  {
    q: 'What is the Founding Plan vs Starter?',
    a: 'Starter focuses on daily structure and habit guidance. Founding adds AI-based adjustments and personalized guidance for people who want the full adaptive system during early access.',
  },
  {
    q: 'Will my data be used responsibly?',
    a: 'Notrack is designed with privacy in mind. Read the Privacy Policy for details on what we collect, why we collect it, and your choices.',
  },
  {
    q: 'Can Notrack help if I have tried diets before and quit?',
    a: 'Yes—that is the core problem Notrack targets. The approach reduces logging friction and focuses on doable daily structure so consistency survives real life—not just week one.',
  },
  {
    q: 'Does Notrack work for beginners who do not know nutrition?',
    a: 'Yes. You do not need to be an expert. The product explains what to do next in plain language—portion patterns, protein ideas, and simple swaps—without turning you into a spreadsheet. For product questions during beta, use the Contact page or WhatsApp from the site footer; response times may vary.',
  },
];
